import Decimal from 'decimal.js';

export const calcPercentage = (current: number, total: number, fractionDigits?: number): number => {
  if (total === 0) return 0;
  return Number(((current / total) * 100).toFixed(fractionDigits));
};

export const numToFix = (num: number, precision: number): number => {
  return Number(num.toFixed(precision));
};

export const sum = (a: number = 0, b: number = 0, precision: number = 2): number => {
  const num1 = new Decimal(a);
  const num2 = new Decimal(b);
  return numToFix(Number(num1.plus(num2)), precision);
};

export const subtract = (a: number = 0, b: number = 0, precision: number = 2): number => {
  const num1 = new Decimal(a);
  const num2 = new Decimal(b);
  return numToFix(Number(num1.minus(num2)), precision);
};

export const divide = (a: number = 0, b: number = 0, precision: number = 2) => {
  const num1 = new Decimal(a);
  const num2 = new Decimal(b);
  return Number(num1.div(num2).toFixed(precision, Decimal.ROUND_DOWN));
};

export const multiply = (a: number = 0, b: number = 0, precision: number = 2) => {
  const num1 = new Decimal(a);
  const num2 = new Decimal(b);
  return numToFix(Number(num1.mul(num2)), precision);
};
